import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUser } from "../../../api/business";

export const fetchUsers = createAsyncThunk("fetchUsers", async () => {
  const response = await getUser();
  return response;
});

const initialState = {
  fcmToken: null,
  notification: {
    isNew: false,
    title: "",
    body: "",
  },
  onlineUsers: [],
  response: null,
  status: 'idle',
  error: null
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset: () => initialState,
    setFCMToken: (state, action) => {
      state.fcmToken = action.payload;
    },
    setNotification: (state, action) => {
      state.notification = action.payload;
    },
    closeNotification: (state, action) => {
      state.notification = action.payload;
    },
    updateOnlineUsers: (state, action) => {
      state.onlineUsers = action.payload;
    },
    updateUserData: (state, action) => {
      // Force update user data and clear any cached state
      state.response = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearUserData: (state) => {
      state.response = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.response = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// Exporting generated action creators directly
export const { reset, setFCMToken, setNotification, closeNotification, updateOnlineUsers, updateUserData, clearUserData } =
  userSlice.actions;
export { userSlice };
